/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {ReactNode, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import {isKeyDown, isShift, isTab} from '@ion/core/src/utils/KeyEventUtils';
import {DLSTheme} from '@ion/dls/src/types/types';
import {MobileSideSheetArrow} from '../sidesheet/MobileSideSheetArrow';

export interface DrawerTypes {
  mobileDrawerZindex?: number;
  children: ReactNode;
  open?: boolean;
  onClose?: () => void;
  onOpen?: () => void;
}

const useStyles = makeStyles<DLSTheme, DrawerTypes>(theme => ({
  content : {
    paddingTop    : 10,
    paddingBottom : 20
  },
  mobileSideSheetIcon : {
    borderTopRightRadius : 10,
    borderTopLeftRadius  : 10
  },
  mobileMenuDrawer : {
    zIndex : ({mobileDrawerZindex}) => `${mobileDrawerZindex} !important` as any
  }
}));

/**
 * @MobileDrawer
 *
 * The MobileDrawer component for more menu items, Only for mobile
 *
 * ```typescript
 *
 *     <MobileDrawer open={bottomSheetOpen}
 *       onClose={closeMoreMenu}
 *       onOpen={openMoreMenu}>
 *       <div>Edit</div>
 *       <div>Delete</div>
 *     </MobileDrawer>
 *
 * ```
 */
export const MobileDrawer = (props: DrawerTypes) => {
  const {
    mobileDrawerZindex,
    children,
    onClose,
    onOpen,
    open = false
  } = props;
  const classes             = useStyles(props);
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const toggleDrawer = open => (event) => {
    if (!isKeyDown(event) && (!isTab(event) && !isShift(event))) {
      setIsOpen(open);
    }
    open ? onOpen?.() : onClose?.();
  };

  return (
    <SwipeableDrawer anchor='bottom'
      classes={{
        paperAnchorBottom : classes.mobileSideSheetIcon,
        ...(!!mobileDrawerZindex && {root: classes.mobileMenuDrawer})
      }}
      open={isOpen}
      onClose={toggleDrawer(false)}
      onOpen={toggleDrawer(true)}>
      <MobileSideSheetArrow smallMode />
      <div className={classes.content}>
        {children}
      </div>
    </SwipeableDrawer>

  );
};

export default MobileDrawer;
